export default __webpack_public_path__ + "static/media/img--legend.cf6c9cdb.png";